import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import { Field, reduxForm, FormSection, change } from 'redux-form';
import agent from '../../agent';
import moment from 'moment';
import Multiselect from 'react-widgets/lib/Multiselect'
import 'react-widgets/dist/css/react-widgets.css'
import europeanCountryCodes from '../../data/european-country-codes';
import Modal from 'react-responsive-modal';

//These options are for both genders
import heightOptions from '../../data/height-options';
import complexions from '../../data/complexions';
import eyeColours from '../../data/eye-colours';
import waistSizes from '../../data/waist-sizes';
import hairColours from '../../data/hair-colours';
import ethnicities from '../../data/ethnicities';

//Female Adult Statistics Options
import bustSizes from '../../data/bust-sizes';
import hipSizes from '../../data/hip-sizes';
import femaleShoeSizes from '../../data/female-shoe-sizes';
import femaleSuitSizes from '../../data/female-suit-sizes';
import femaleDressSizes from '../../data/female-dress-sizes';
import femaleBraSizes from '../../data/female-bra-sizes';

//Male Adult Statistics Options
import chestSizes from '../../data/chest-sizes';
import collarSizes from '../../data/collar-sizes';
import maleShoeSizes from '../../data/male-shoe-sizes';
import maleSuitSizes from '../../data/male-suit-sizes';
import insideLegOptions from '../../data/inside-leg-options';
import outsideLegOptions from '../../data/outside-leg-options';

//Kids Statistics Options
import kidsShoeSizes from '../../data/kid-shoe-sizes';
import kidsClothingOptions from '../../data/kid-clothing-options';

// Measurements
import statRegion from '../../data/stat-region'
import statUnits from '../../data/stat-units'
import statAge from '../../data/stat-age'


const renderMultiselect = ({ input, data, valueField, textField }) => {
  let value = []
  if (typeof input.value == 'string') {
    value = JSON.parse(`[${input.value}]`)
    value = data.filter(item => value.includes(parseInt(item.id)) )
  } else {
    value = input.value
  }

  return (
    <Multiselect {...input}
      name={input.name}
      className="am-multi-select"
      onBlur={() => input.onBlur()}
      data={data}
      valueField={valueField}
      textField={textField}
      value={value}
    />
  )
}

const FieldGroup = (props) => {
	return (<div className="column column-block grid-x">
		<div className="small-4 cell">
		    <label htmlFor={props.name} className="text-left middle">
          <div className="truncate">{props.label}</div>
          { props.name === 'ethnicities' ? <div>(click all that apply)</div> : <div></div> }
        </label>
	    </div>
		<div className="small-8 cell">
      {
        props.name === 'ethnicities'
        ? 
        <Field
            name={`statistics[${props.name}]`}
            component={renderMultiselect}
            data={props.stats}
            valueField="id"
            textField="name">
          </Field>

        : <Field 
            name={`statistics[${props.name}]`} 
            component="select" 
            id={props.name}>
  		    	 <option value="">{`Select ${props.label}`}</option>
  		    	{ 
  		    		props.stats.map( item => 
  		    			<option 
                  key={item.id} 
                  value={item.id}> 
                  {
                    item.AL
                    ? item[props.statUnit]
                    : item.label || item.name
                  }
                  </option> )
  		    	}
	        </Field>
      }
		</div>
	</div>)	
}

class Statistics extends Component {
	state = {
 		region: 'US',
		regions: ['AU', 'NZ', 'US', 'UK', 'EU'],
		regionBasedStats: ['Bra Size', 'Dress Size', 'Shoe Size',
                     'Suit Size', 'Kids Clothing', 'Kids Shoe Size'],
    statisticsOptions: [],
    // Note: get the values from artist
    statUnit: 'IN',
    statAge: 'ADLT'
 	}
  
 	componentWillMount() {
    // TODO: get country by region
    // let stats = this.props.artist.statistics;
    // let result = [];
    // for(var i in stats) {
    //   for(var j in stats[i]) {
    //     result.push([j, stats[j]]);
    //   }
    // }

  	this.setState({
      region: this.props.artist.statistics_region,
      statUnit: this.props.artist.statistics_unit,
      statAge: this.props.artist.measurement_sizing,
			statisticsOptions: this.buildStatistics(this.props.artist.statistics_region, this.props.artist.measurement_sizing)
		});
 	}

  onChangeUnit = (event) => {
    this.setState({
      statUnit: event.target.value
    })
  }

  onChangeAge = (event) => {
    const statistics = this.buildStatistics(this.state.region, event.target.value)

    this.setState({
      statisticsOptions: statistics,
      statAge: event.target.value
    })
  }

 	onChangeRegion = (event) => {
    const statistics = this.buildStatistics(event.target.value, this.state.statAge)

    let statUnit = 'AL'
    if (event.target.value == 'US') {
      statUnit = 'IN'
    }

    this.props.dispatch(change('artistStatisticsProfile', 'artist.statistics_unit', statUnit))

 		this.setState({
 			statisticsOptions: statistics,
      region: event.target.value,
      statUnit: statUnit
 		})
 	}

 	filterByRegion (obj, region) {
    const selectedRegion = region || this.state.region;

    return obj.map(items => {
			const name = items.values.filter(item => item.name && item.region === selectedRegion)[0].name;
			return {id: items.id, name: name, label: `${name} ${selectedRegion}`};
		})

  }

	getRegionByCountry(code) {
		let region = code

    // NOTE:
    // We are defaulting region to US if it does not belong
    // to the region array and to the european countries.
    if (this.state.regions.indexOf(code) === -1 &&
        europeanCountryCodes.indexOf(code) === -1) region = 'US'
    if (europeanCountryCodes.indexOf(code) !== -1) region = 'EU'
    return region
	}

	isChild() {
		const dateNow = moment();
		const birthdate = moment(this.props.artist.birth_date);

		return moment(dateNow, 'YYYYMMDD').diff(birthdate, 'year') <= 16;
	}

	isArtistChild(statAge) {
    return statAge === 'ADLT' ? false : true
		return this.props.artist.birth_date ? this.isChild() : false;
	}

	buildStatistics(region, statAge) {
		const artist = this.props.artist;
    const gender = artist.gender;

    return this.buildStatisticsOptions(gender, this.isArtistChild(statAge), region);
	}

	buildStatisticsOptions(gender, isChild, region) {
		const defaultOptions = [
      {label: 'Hair Colour', name: 'hair_colour', values: hairColours},
      {label: 'Eye Colour',  name: 'eye_colour',  values: eyeColours},
      {label: 'Complexion',  name: 'complexion',  values: complexions},
      {label: 'Height',      name: 'height',      values: heightOptions},
      {label: 'Waist Size',  name: 'waist_size',  values: waistSizes}
    ];

    const variationOptions = this.getStatsFor(gender, isChild, region);
    const arrangedFields = this.getFieldsArrangement(gender, isChild);
    
    
    return this.setOptionsArrangement(arrangedFields, defaultOptions.concat(variationOptions));
	}

	getStatsFor (gender, isChild, region) {
    //Let us set here the region to filter out statistics.
    // this.state('region', region);
    // this.setState({ region: region })


    let statsOptions = []

    if (gender === 'female' || gender == 'both' || gender == 'other') 
      statsOptions = statsOptions.concat(this.getFemaleParams(region))

    if (gender === 'male' || gender == 'both' || gender == 'other') 
      statsOptions = statsOptions.concat(this.getMaleParams(region))

    
    const ethnicitiesOpts = {label: 'Ethnicities', name: 'ethnicities', values: ethnicities};
    statsOptions = statsOptions.concat(ethnicitiesOpts);

    if (isChild) {
      const childParams = this.getChildParams(region);
      return statsOptions.concat(childParams);
    }

    return statsOptions;
  }

  getFieldsArrangement (gender, isChild) {
    let params = [];
    let fields = ['hair_colour', 'eye_colour', 'complexion', 'height', 'waist_size'];

    if (gender === 'male' || gender === 'both' || gender === 'other') {
      if (isChild) {
        params = params.concat(['chest_size', 'kids_clothing', 'kids_shoe_size']);
      } else {
        params = params.concat(['suit_size', 'chest_size', 'collar_size',  'inside_leg',
                          'outside_leg', 'shoe_size']);
      }
    } 

    if (gender === 'female' || gender === 'both' || gender === 'other') {
      if (isChild) {
        params = params.concat(['bust_size', 'hip_size', 'kids_clothing', 'kids_shoe_size']);
      } else {
        params = params.concat(['bust_size', 'bra_size', 'hip_size',
                          'dress_size', 'shoe_size', 'suit_size']);
      }
    }

    fields = fields.concat(params);
    //The reason we separate Ethnicities is because
    //of the select-2 behavior layout
    fields = fields.concat('ethnicities');
    return fields;
  }

  setOptionsArrangement (fields, options) {
    let toRet = fields.map(field => {
      return options.filter( option => option.name === field)[0];
    });

    console.log('Getting Stat options', fields, toRet)

    return toRet.filter(Boolean)
  }

  getChildParams (region) {
    //Below are the list of child specific statistics:
    //BOTH GENDERS:
    //Kids Clothing Options
    //Kids Shoe Size
    //
    //FEMALE:
    //Bust Size
    //Hip Size
    //
    //MALE:
    //Chest

    return [
      {label: 'Kids Shoe Size', name: 'kids_shoe_size', values: this.filterByRegion(kidsShoeSizes, region)},
      {label: 'Kids Clothing', name: 'kids_clothing', values: this.filterByRegion(kidsClothingOptions, region)}
    ];
  }

  getFemaleParams (region) {
    //Below are the list of female specific statistics:
    //Bust Size
    //Bra Size
    //Hip Size
    //Dress Size
    //Shoe Size
    return [
      {label: 'Bust Size',  name: 'bust_size',  values: bustSizes},
      {label: 'Bra Size',   name: 'bra_size',   values: this.filterByRegion(femaleBraSizes, region)},
      {label: 'Hip Size',   name: 'hip_size',   values: hipSizes},
      {label: 'Dress Size', name: 'dress_size', values: this.filterByRegion(femaleDressSizes, region)},
      {label: 'Suit Size',  name: 'suit_size',  values: this.filterByRegion(femaleSuitSizes, region)},
      {label: 'Shoe Size',  name: 'shoe_size',  values: this.filterByRegion(femaleShoeSizes, region)}
    ];
  }

  getMaleParams (region) {
    //Below are the list of male specific statistics:
    //Chest Size
    //Suit Size
    //Shoe Size
    //Collar Size
    //Inside Leg
    //Outside Leg
    return [
      {label: 'Collar Size', name: 'collar_size', values: collarSizes},
      {label: 'Chest Size',  name: 'chest_size',  values: chestSizes},
      {label: 'Inside Leg',  name: 'inside_leg',  values: insideLegOptions},
      {label: 'Outside Leg', name: 'outside_leg', values: outsideLegOptions},
      {label: 'Suit Size',   name: 'suit_size',   values: this.filterByRegion(maleSuitSizes, region)},
      {label: 'Shoe Size',   name: 'shoe_size',   values: this.filterByRegion(maleShoeSizes, region)}
    ];
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    console.log(`Selected: ${selectedOption.label}`);
  }

  submit = (values, dispatch, props) => {
    let stats = JSON.stringify(values.artist.statistics)
    // let stats = {
    //   hair_colour: {
    //     label: 'Hair Colour',
    //     value: values.artist.statistics.hair_colour
    //   },
    //   complexion: {
    //     label: 'Complexion',
    //     value: values.artist.statistics.complexion
    //   }
    // }
    let id = this.props.initialValues.artist.id
    let artist_payload = {
      statistics_region: values.artist.statistics_region,
      measurement_sizing: values.artist.measurement_sizing,
      statistics_unit: values.artist.statistics_unit,
      id: values.artist.id,
      statistics: values.artist.statistics
    }
    console.log('onsubmit-stat', values, artist_payload)
    agent.Artist.updateDetails(id, artist_payload).then(({k}) => {
      this.setState({ showModal_info: true })
    })
    // if (!props.publicToken) { return props.onSubmit(props.handleSubmit) }
    // return props.onSubmit(props.handleSubmit)
  }
  onCloseModal = () => {
    this.setState({ showModal_info: false });
  }

 	render() {
 		const { handleSubmit, previousPage, nextPage, pristine, submitting, publicToken, initialValues, artist, disableButton } = this.props
 		const { regions, statisticsOptions } = this.state
    console.log('render-stat', initialValues, statisticsOptions, artist)
 		return (
 			<form onSubmit={handleSubmit} className="checking-statistics-form label-blue" id="update-statistics-form">
        <FormSection name='artist'>
    			<section className="section gray-bg">
    				<div className="grid-x align-center">
    					<div className="small-12 medium-10 large-8 cell">
    					
    					<div className="text-center">
    						<h3>Please check your profile statistics are all correct</h3>
    						<p>Please check your profile statistics below</p>
    					</div>

    					<div className="row">
    				      	<div className="small-12 medium-8 column medium-centered text-center">
                      
                      <div className="row">
                        <div className="small-4 column">
                          <label htmlFor="region">Region</label>
                        </div>
                        <div className="small-8 column">
                            <Field 
                              name="statistics_region" 
                              component="select"
                              onChange={this.onChangeRegion} >
                              {
                                statRegion.map(region => (
                                  <option key={region.id} 
                                    value={region.value}>{region.value}</option> 
                                ))
                              }
                            </Field>
                        </div>
                      </div>

                      <div className="row">
                        <div className="small-4 column">
                            <label htmlFor="region">
                              <div className="truncate">Imperial/Metric</div>
                            </label>
                        </div>
                        <div className="small-8 column">
                          <Field 
                            name="statistics_unit"
                            component="select"
                            onChange={this.onChangeUnit} >
                            {
                              statUnits.map(unit => (
                                <option key={unit.id} 
                                  value={unit.value}>{unit.name}</option> 
                              ))
                            }
                          </Field>
                        </div>
                      </div>

                      <div className="row">
                        <div className="small-4 column">
                          <label htmlFor="region">
                            <div className="truncate">Child/Adult</div>
                          </label>
                        </div>
                        <div className="small-8 column">
                          <Field 
                            name="measurement_sizing" 
                            component="select"
                            onChange={this.onChangeAge} >
                            {
                              statAge.map(age => (
                                <option key={age.id} 
                                  value={age.value}>{age.name}</option> 
                              ))
                            }
                          </Field>
                        </div>
                      </div>

                      
    				        </div>
    				    </div>
    				    <br/>
    					
    					<div className="row small-up-1 medium-up-2">

    						{
    							statisticsOptions.map((option,index) => (
    								<FieldGroup 
                      statUnit={this.state.statUnit}
                      statAge={this.state.statAge}
                      option={option}
    									key={index}
    									name={option.name}
    									label={option.label}
    									stats={option.values} />
    							))
    						}

    					 </div>

    					</div>
    				</div>
    			</section>

    			<section className="section">
    				<div className="grid-x align-center">
    					<div className="small-12 cell text-center">
                
              {
                previousPage &&
                <button 
                  className="button primary previous" 
                  type="button" 
                  onClick={previousPage} >Previous</button>
              }

              {
                nextPage 
                ? <button className="button primary next" type="submit">Next</button>
                : <button className="button primary" 
                    type="submit" 
                    disabled={pristine || submitting || disableButton}>
                      {submitting || disableButton ? 'Saving...' : 'Save' }
                  </button>
              }



    					</div>
    				</div>
    			</section>
        </FormSection>
	    </form>
		)
 	}
}

Statistics = reduxForm({
  form: 'artistStatisticsProfile', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
  // asyncValidate,
  // asyncBlurFields: ['first_name', 'last_name', 'email']
})(Statistics)

const mapStateToProps = (state, ownProps) => {

  let artist_storage = JSON.parse(window.localStorage.getItem('artist_jwt'))
  let artistInfo = artist_storage.artist

  const stats = artistInfo.statistics
  const region = artistInfo ? artistInfo.statistics_region : 'US'

  const currentEthnicities = stats.ethnicities ? JSON.parse(`[${stats.ethnicities}]`) : []
  const parsedEthnicities = ethnicities.filter(item => currentEthnicities.includes(parseInt(item.id)) )

  if (stats.licenses_held) {
    delete stats.licenses_held
  }

  return ({
    initialValues: {
      artist: {
        statistics: {
          ...stats,
          ethnicities: parsedEthnicities
        },
        measurement_sizing: artistInfo.measurement_sizing,
        statistics_region: artistInfo.statistics_region,
        statistics_unit: artistInfo.statistics_unit,
        id: artistInfo.id
      }
    },
    enableReinitialize: true
  })
}

/*
const mapStateToProps = state => ({
  initialValues: {
    artist: {
      statistics: state.common.artistInfo.statistics,
      measurement_sizing: state.common.artistInfo.measurement_sizing,
      statistics_region: state.common.artistInfo.statistics_region,
      statistics_unit: state.common.artistInfo.statistics_unit,
      id: state.common.artistInfo.id
    }
  },
  enableReinitialize: true
})
*/
const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);




// WEBPACK FOOTER //
// ./src/components/profile/Statistics.js